import React from 'react';

const STATUS_CONFIG = {
    Pendente:     { color: '#fa8c16', bg: '#fff7e6', border: '#ffd591', dot: '#fa8c16', icon: '○' },
    'Em Aberto':  { color: '#fa8c16', bg: '#fff7e6', border: '#ffd591', dot: '#fa8c16', icon: '○' },
    Pago:         { color: '#52c41a', bg: '#f6ffed', border: '#b7eb8f', dot: '#52c41a', icon: '●' },
    Inadimplente: { color: '#cf1322', bg: '#fff1f0', border: '#ffa39e', dot: '#cf1322', icon: '!' },
    Ajuizado:     { color: '#722ed1', bg: '#f9f0ff', border: '#d3adf7', dot: '#722ed1', icon: '⚖' },
};

const Status = ({ value, icon }) => {
    const cfg = STATUS_CONFIG[value];
    if (!cfg) {
        return (
            <span style={{
                display: 'inline-flex', alignItems: 'center', gap: 6,
                padding: '2px 10px', borderRadius: 12,
                background: '#fafafa', border: '1px solid #e8e8e8',
                color: '#8c8c8c', fontSize: 12, fontWeight: 500,
                lineHeight: '20px',
            }}>
                {value || '-'}
            </span>
        );
    }

    return (
        <span style={{
            display: 'inline-flex', alignItems: 'center', gap: 6,
            padding: '2px 10px', borderRadius: 12,
            background: cfg.bg, border: '1px solid ' + cfg.border,
            color: cfg.color, fontSize: 12, fontWeight: 600,
            lineHeight: '20px', whiteSpace: 'nowrap',
        }}>
            <span style={{
                width: 6, height: 6, borderRadius: '50%',
                background: cfg.dot, flexShrink: 0,
                boxShadow: value === 'Pendente' ? '0 0 0 2px ' + cfg.bg + ', 0 0 0 3px ' + cfg.border : 'none',
            }} />
            {value}
            {icon}
        </span>
    );
};

export default Status;
